<template>
    <div>
        <CCard style="display: grid;padding: 5px 10px 0px;">
            <a :href="item.url" target="_blank" style="display: grid;">
                <img :src="item.primary_image" alt class="image-card" />
            </a>
            <div v-if="item.discount" class="ribbon">
                <span
                    class="bg-danger text-light"
                >% {{ Math.round((item.discount * 100) / (item.old_price)) }}</span>
            </div>
            <div v-if="item.price === 0 || !item.in_stock" class="ribbon">
                <span class="bg-dark text-light">{{ $t('product.unavailable') }}</span>
            </div>
            <p class="title-card">{{ item.name.substring(0, 30) }}...</p>
            <div class="price-card">
                <div v-if="item.price > 0">
                    <span v-if="item.discount" style="font-size: 14px;">
                        <del>{{ item.old_price.toLocaleString() }}</del>
                    </span>
                    <span style="color: black;font-weight: 700;">{{ item.price.toLocaleString() }}</span>
                    <span>{{ $t('rial') }}</span>
                </div>
            </div>
            <CButton
                v-if="$policy('store').join"
                color="primary"
                style="height: 30px;"
                class="mb-2"
                @click="modal.show = true"
                :disabled="item.price === 0"
            >{{ $t('product.link') }}</CButton>
            <div v-else style="height: 37px;"></div>
        </CCard>

        <CModal color="primary" :show.sync="modal.show">
            <template #header-wrapper>
                <span></span>
            </template>
            <Loading :showIn="'modal'" />
            <Message />
            <div class="d-flex flex-column" v-if="modal.msg_err">
                <span class="alert alert-danger mb-0">{{ modal.msg_err }}</span>
            </div>
            <div class="d-flex flex-column" v-else>
                <p>{{ $t('promotion.link_promotion_code_notice') }}</p>
                <div>
                    <span class="mx-3">{{ shortLink }}</span>
                    <CButton color="info" @click="copyFunction(shortLink)" v-if="shortLink">
                        <FaIcon icon="copy" />
                    </CButton>
                </div>
            </div>
            <template #footer-wrapper>
                <span></span>
            </template>
        </CModal>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { LinkType } from '@/constants'

export default {
    name: 'ProductCard',

    props: {
        item: {
            default() {
                return {
                }
            },
            type: Object
        }
    },

    data() {
        return {
            modal: {
                show: false,
                msg_err: null,
                item: []
            },
            shortLink: ''
        }
    },

    watch: {
        "modal.show"(val) {
            if (val) {
                const link = {
                    title: this.item.name,
                    href: this.item.url,
                    type: LinkType.EXCLUSIVE,
                    store_name: this.item.store.name
                }
                this.submit(link)
            }
        }
    },

    methods: {
        ...mapActions({
            create: 'link/create',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        copyFunction(val) {
            navigator.clipboard.writeText(val);
        },
        submit(link) {
            this.modal.msg_err = null
            this.setShowLoading('modal')
            this.create(link).then(res => {
                this.shortLink = res.data.shorted_link
                this.setShowLoading(false, 'modal')
            }).catch(res => {
                this.setShowLoading(false, 'modal')
                this.modal.msg_err = this.$t('tags.'+res.tag, {attribute: link.store_name})
            })
        }
    }
}
</script>

<style scoped>
.price-card {
    display: grid;
    align-items: center;
    justify-content: flex-end;
    height: 30px;
}
.price-card div {
    display: flex;
    place-items: center;
    gap: 10px;
}
.title-card {
    margin: 5px 0 -5px;
    height: 50px;
    font-size: 13px;
    line-height: 20px;
}
.image-card {
    height: 130px;
    width: 100px;
    align-self: center;
    justify-self: center;
    position: relative;
}
.ribbon {
    margin: 130px auto;
    width: 80px;
    height: 80px;
    display: block;
    position: absolute;
    overflow: hidden;
    bottom: 43px;
}
.ribbon span {
    width: 140px;
    height: 24px;
    top: 20px;
    right: -40px;
    position: absolute;
    display: block;
    color: #333;
    font-size: 14px;
    color: white;
    text-align: center;
    line-height: 24px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
}
</style>
